import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import dayjs from 'dayjs';

export const parseStringifiedDuration = (
  duration: DateTimeRange,
): DateTimeRange => {
  const durationObject = { ...duration };

  if (durationObject.type === 'absolute') {
    durationObject.startAfter = dayjs.tz(durationObject.startAfter);
    durationObject.endBefore = dayjs.tz(durationObject.endBefore);
  }

  if (durationObject.type === 'since') {
    durationObject.startAfter = dayjs.tz(durationObject.startAfter);
  }

  if (durationObject.type === 'last') {
    durationObject.value = Number(durationObject.value);
  }

  return durationObject;
};
